import { Trans } from 'react-i18next';
import environment from '@environment';
import './faqs-link.scss';

const FaqsLink = () => {
  const key = 'account.recurringPayment.haveQuestionsCta';

  const url = environment.URLS.RECURRING_PAYMENT.FAQS;

  return <p className="faqs-link">
    <Trans
      i18nKey={key}
      defaults="Have questions? <a>Visit out FAQs for more info</a>"
      components={{
        a: <a href={url} target="_blank" rel="noreferrer"></a>,
      }}
    />
  </p>
}

export default FaqsLink;